import Button from '@components/dataEntry/button/Button';
import { useCollection } from '@nandorojo/swr-firestore';
import React from 'react';
import styled from 'styled-components';

const ListWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Box = styled.div`
  img {
    max-width: 50px;
    max-height: 50px;
    object-fit: contain;
  }
`;

const ItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  span {
    font-size: 12px;
  }
`;

const Empty = styled.div`
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: var(--subTextColor);
  padding: 16px 0;
`;

const BtnWrap = styled.div`
  display: flex;
  gap: 4px;
`;

type Props = {
  isEditMode?: boolean;
  handleEdit?: (item) => void;
  handleDelete?: (item) => void;
  handleClick?: (any) => void;
};

function EmoticonList({
  isEditMode,
  handleEdit,
  handleDelete,
  handleClick,
}: Props) {
  const { data: list } = useCollection<IEmoticonItem>('emoticon', {
    listen: true,
    orderBy: ['order', 'asc'],
  });

  if (!list || list!.length === 0) return <Empty>이모티콘 없음</Empty>;

  return (
    <>
      <ListWrap>
        {list &&
          list.map((item, i) => {
            return (
              <Box key={i}>
                <ItemWrap
                  onClick={(e) => {
                    if (handleClick) handleClick(item.imgURL);
                  }}
                >
                  <img src={item.imgURL} alt={item.title} loading="lazy" />
                  <span>/{item.title}</span>
                  {/* {isEditMode && <span>{item.order}</span>} */}
                </ItemWrap>
                {isEditMode && (
                  <BtnWrap>
                    <Button
                      size="sm"
                      shape="stroke"
                      onClick={() => {
                        if (handleEdit) handleEdit(item);
                      }}
                    >
                      수정
                    </Button>
                    <Button
                      size="sm"
                      onClick={() => {
                        if (handleDelete) handleDelete(item);
                      }}
                    >
                      삭제
                    </Button>
                  </BtnWrap>
                )}
              </Box>
            );
          })}
      </ListWrap>
    </>
  );
}

export default React.memo(EmoticonList);
